@let cp = content();
@if (cp) {
  <div class="text-left">
    <div class="track-info line-clamp-1 sm:line-clamp-2 font-semibold">
      {{ trackName() }}
    </div>
    @if (cp.contentType !== 'MicBreak' && cp.performerName) {
      <div>
        {{ cp.performerName }}
      </div>
    }
    @if (showAlbum() && cp.releaseName) {
      <div class="line-clamp-1">
        {{ cp.releaseName }}
      </div>
    }
  </div>
}
